import React from 'react';

const RequiredInformation = () => (
  <div className="form-group">
    <span className="error">* Required Information</span>
  </div>
);

export default RequiredInformation;
